import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevo-acceso',
  templateUrl: './nuevo-acceso.component.html',
  styleUrls: ['./nuevo-acceso.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class NuevoAccesoComponent implements OnInit {
  @Output() cerrarPopUpRol: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<any>();
  editar: boolean;
  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  dataRolAcceso: any;
  repSistemas: any = [];
  repRoles: any = [];
  id_rol_path: any;
  repPermisos: any = [];

  user: any;
  ipAddress: any;
  formularioRol: FormGroup;
  idEmpresa: string;
  Titulo: string;
  disableSelect: boolean = false;

  constructor(
    private securityService: SecurityService,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus
  ) {
    try {
      this.dataRolAcceso = this.securityService.dataRolAcceso;

    } catch (error) {
      this.router.navigate(['/usuarios/listado']);
    }

    this.Titulo = "Editar Rol de acceso";
    this.cerrarPopUpRol = new EventEmitter();

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.formularioRol = new FormGroup({
      id_accesos: new FormControl(this.dataRolAcceso.id_accesos),
      id_user: new FormControl(this.dataRolAcceso.id_user),
      id_sistemas: new FormControl(this.dataRolAcceso.id_sistemas),
      id_roles: new FormControl("", [Validators.required]),
      Ruta: new FormControl("", [Validators.required]),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });

    this.formularioRol.controls['id_roles'].setValue(this.dataRolAcceso.id_roles);
    this.formularioRol.controls['Ruta'].setValue(this.dataRolAcceso.Ruta_dsc);
  }

  ngOnInit() {
    this.ObtenerListaRoles();
    this.ObtenerListaPermisos();
    this.id_rol_path = this.dataRolAcceso.id_roles;
  }

  filterItemsOfId() {
    return this.repRoles.filter(x => x.id_sistemas == this.dataRolAcceso.id_sistemas);
  }

  filterItemsOfIdPath() {
    return this.repPermisos.filter(x => x.id_roles == this.id_rol_path && x.Ruta_dsc != null);
  }

  FiltrarPath(element: any) {
    this.id_rol_path = element.id_roles;
    this.filterItemsOfIdPath();
  }

  ActualizarAcceso() {
    if (this.formularioRol.invalid) {

      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verificar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      })
      return;
    }
    Swal.fire({
      title: 'Espere',
      text: 'Actualizando Información',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.securityService.ActualizarAcceso(this.formularioRol.getRawValue())
      .subscribe(resp => {
        Swal.fire({
          title: "Éxito",
          text: "Acceso actualizado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res => {
          if (res.value) {
            this.cerrarPopUpRol.emit();
            this.refresh.emit();
          }
        });
      }, (err: HttpErrorResponse) => {

        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "ACCESO NO ACTUALIZADO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      });

  }

  ObtenerListaRoles() {
    this.loading = true;
    this.securityService.ObtenerListaRoles(this.user.id_empresa)
      .subscribe(resp => {
        this.repRoles = resp

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  ObtenerListaPermisos() {
    this.loading = true;
    this.securityService.ObtenerListaPermisos(this.user.id_empresa)
      .subscribe(resp => {
        this.repPermisos = resp

        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA PERMISOS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  CerrarPopUp() {
    this.cerrarPopUpRol.emit();
  }
}
